import React, { PureComponent } from 'react';
import cx from 'classnames';

import Icon from '~/core/scripts/components/Icon';

class Answers extends PureComponent {
  render() {
    const {
      index, answers, finished, correctAnswer,
      onAnswer, selectedAnswer
    } = this.props;

    return (
      <div className="quizitem__answers">
        {answers.map((answer, i) => {
          const correct = finished && answer === correctAnswer;

          return (
            <div key={`${index}__${answer}__${i}`} className="quizitem__answer">
              <button
                className={cx('answer-button', {
                  selected: selectedAnswer === answer,
                  finished: finished,
                  wrong: finished && answer !== correctAnswer,
                  correct
                })}
                disabled={finished}
                onClick={() => onAnswer(answer)}
              >
                {answer} {correct && <Icon type="check" />}
              </button>
            </div>
          );
        })}
      </div>
    );
  }
}

export default Answers;
